const nameRules = [v => !!v || 'Name is required'];
const emailRules = [v => !!v || 'Email is required',
(v) => /^\S+@\S+\.\S+$/.test(v) ? true : "This field must contain a valid email address"
]
const passwordRules = [
    v => v.length >= 6 || "This field is at least 6 characters long.",
    v => v.length <= 20 || "This field is a maximum of 20 characters long.",
    v => /[ `¿¡!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/.test(v) || "This field must contain at least one symbol.",
    v => /[0123456789]+/.test(v) || "This field must contain at least one number.",
    v => /[abcdefghijklmnñopqrstuvwxyz]+/.test(v) || "This field must contain at least one letter."
]
const rolRules = [v => !!v || 'Rol is required'];

export {
    nameRules,emailRules,passwordRules,rolRules
}